export class Tag {
  constructor(
    public isGeneral: boolean,
    public id: number,
    public name: string,
  ) {}
}
